import { Typeahead } from 'react-bootstrap-typeahead'
import styled from 'styled-components'

import { FieldContainer } from '../SharedComponents/FieldContainer/FieldContainer'

export const AutocompleteInputField = ({
	componentRef,
	newSelectionPrefix,
	error,
	clearButton = true,
	emptyLabel = 'Nenhuma sugestão encontrada',
	options = [],
	placeholder,
	onChange,
	label,
	containerProps,
	disabled,
	...props
}) => {
	const inputId = props?.id || props?.name
	return (
		<FieldContainer
			label={label}
			disabled={disabled}
			fieldMessage={error}
			feedbackType={error ? 'error' : 'default'}
			containerProps={containerProps}
			htmlFor={inputId}
			required={props?.required}
		>
			<CustomTypeHead
				{...props}
				disabled={disabled}
				clearButton={clearButton}
				options={options}
				placeholder={placeholder}
				onChange={onChange}
				emptyLabel={emptyLabel}
				newSelectionPrefix={newSelectionPrefix}
				selectHintOnEnter={true}
				ref={componentRef}
			/>
		</FieldContainer>
	)
}

const CustomTypeHead = styled(Typeahead)`
	width: 100%;

	.rbt {
		display: flex;
	}

	.rbt-input {
		border: none !important;
		padding: 0 !important;
		height: fit-content !important;
		display: flex;
	}

	.rbt-input input {
		font-size: 1rem !important;
		text-overflow: ellipsis;
	}

	.rbt-input-main {
		font-size: 1rem !important;
		min-height: 1.5rem;
		color: #374151;

		::placeholder {
			font-size: 1rem !important;
			color: #9ca3af;
		}
	}

	.rbt-input-wrapper {
		min-height: 1.5rem;
		align-items: center;
		width: 100%;
	}

	.rbt-input-hint {
		display: none;
	}

	.rbt-close {
		color: #ff7708;
		opacity: 1;
		margin-left: 8px;
	}

	.rbt-close:hover {
		opacity: 0.8;
	}

	.dropdown-menu {
		z-index: 1000 !important;
		margin-top: 16px !important;
		margin-left: 0 !important;
		width: 100% !important;
		min-width: 100% !important;
		max-width: 100%;
		max-height: 224px !important;
		overflow-x: hidden;
		overflow-y: auto;
		border-radius: 0.5rem !important;
		border: 1px solid #d1d5db !important;
		background: #fff !important;
		box-shadow:
			0 20px 25px -5px rgb(0 0 0 / 0.1),
			0 8px 10px -6px rgb(0 0 0 / 0.1) !important;
		padding: 0.25rem 0 !important;
	}

	.dropdown-item {
		padding: 0.75rem 1rem !important;
		font-size: 0.875rem !important;
		line-height: 1.25rem;
		color: #1f2937 !important;
		border: none;
	}

	.dropdown-item:hover,
	.dropdown-item.active,
	li.active > a.dropdown-item {
		background-color: #f3f4f6 !important;
		color: #1f2937 !important;
	}

	@media (max-width: 767px) {
		.dropdown-menu {
			max-height: 300px !important;
		}
	}
`
